var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{ref:"turnstile-dialog",staticClass:"turnstile-dialog"},[_c('div',{staticClass:"turnstile-dialog__contents"},[_c('div',{staticClass:"ot-card"},[_c('div',{ref:"turnstile-widget",staticClass:"turnstile-widget"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }